import React from "react";
import { Search as SearchIcon } from "@piiqtechnologies/svg-icons";
import { PeekTextField, PeekInputAdornment, useTheme, PeekTypography } from "@piiqtechnologies/ui-components";
export const SearchText = ({ searchText, onChange, placeholder, fullWidth, disabled }) => {
    const theme = useTheme();
    return (React.createElement(PeekTextField, { sx: {
            m: 0,
            minWidth: fullWidth ? "100%" : "fit-content",
            backgroundColor: "common.white",
            borderRadius: theme.spacing(2),
            "& .MuiInput-root": {
                mt: 0,
                height: theme.spacing(3.8),
                minHeight: "unset !important",
                borderRadius: theme.spacing(2),
            },
            input: {
                marginRight: theme.spacing(1.6),
                "&::placeholder": {
                    opacity: 1,
                    color: theme.palette.grey[300],
                },
            },
        }, disabled: disabled, variant: "standard", value: searchText || "", fullWidth: fullWidth, onChange: (event) => onChange(event.target.value), InputLabelProps: { required: true }, InputProps: {
            placeholder: placeholder || "Search",
            disableUnderline: true,
            "aria-label": "Search",
            startAdornment: (React.createElement(PeekInputAdornment, { position: "end" },
                React.createElement(PeekTypography, { variant: "h3", color: "text", display: "flex", sx: { ml: 1 } },
                    React.createElement(SearchIcon, { color: theme.palette.grey[300] })))),
        } }));
};
export default SearchText;
